// extracted by mini-css-extract-plugin
export default {"map":"Contact_map__RZuNU","loader":"Contact_loader__J-Zva","animMarker":"Contact_animMarker__4wReZ","animShadow":"Contact_animShadow__nnL2k"};